import {
  AfterContentInit,
  Component,
  ContentChildren,
  HostBinding,
  Input,
  QueryList,
} from '@angular/core';
import { ButtonDirective } from '../../directives/button.directive';

/**
 * Sample usage
 * ``` html
 * <mpro-button-group>
 *   <button class="mpro-btn" color="blue" hue="300" mproButtton="secondary">Button 1</button>
 *   <button class="mpro-btn" color="red" hue="500" mproButtton="secondary">Button 2</button>
 *   <button class="mpro-btn" color="teal" hue="800" mproButtton="secondary">Button 3</button>
 * </mpro-button-group>
 * ```
 */
@Component({
  selector: 'mpro-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
})
export class ButtonGroupComponent implements AfterContentInit {
  @Input() @HostBinding('disabled') public disabled?: boolean | string;
  @Input() public title: string;
  @Input() public dark: boolean = false;
  @Input() public isFromSizeOfPrize: boolean = false;

  @ContentChildren(ButtonDirective)
  private buttons: QueryList<ButtonDirective>;

  public ngAfterContentInit() {
    setTimeout(() => {
      this.buttons.forEach((button) => {
        button.disableMouseEventStyleChanges = true;
        button.dark = this.dark;
        button.disabled = this.disabled;
        button.ngOnInit();
      });
    });
  }
}
